export default "__VITE_ASSET__3f494dfe__"